import { render, staticRenderFns } from "./SpecifyShare.vue?vue&type=template&id=8892dfbe&scoped=true"
import script from "./SpecifyShare.vue?vue&type=script&lang=js"
export * from "./SpecifyShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8892dfbe",
  null
  
)

export default component.exports